import axios from "@/api/axiosInstance";

export const exportMatchbackSalesItemizedReportCsv = async (
  intacctId: string,
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    `/api/private/stochastic/roi-dashboard/matchback-sales/export/csv`,
    {
      responseType: "blob",
      headers: {
        Accept: "text/csv",
      },
      params: { intacctId },
    },
  );

  return response.data;
};
